import { FilterInputProps } from './types';

import * as S from './styles';

const FilterInput: React.FC<FilterInputProps> = ({
  placeholder,
  value,
  icon,
  className,
  onChange,
  ...props
}) => {
  return (
    <S.Container className={className}>
      {icon && icon}
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        data-testid="filterInput"
        {...props}
      />
    </S.Container>
  );
};

export default FilterInput;
